import React, { useRef, useState } from 'react'

import { Box } from '@mui/system';
import play from 'assets/images/play.svg'

const VideoFrame = ({ fileName, frameSx, videoSx }) => {

    const [playButtonVisibliy, setPlayButtonVisibility] = useState(true)
    let videoRef = useRef(null)

    const playClickHandler = () => {
        videoRef.play()
    }

    return (
        <Box sx={{
            borderRadius: { xs: 2 },
            overflow: 'hidden',
            display: 'flex',
            background: '#e2e2e2',
            position: 'relative',
            margin: -1,
            WebkitTransform: 'translateZ(0)',
            transform: 'translateZ(0)',
            '& video': { videoSx }, ...frameSx
        }}>
            <Box onClick={playClickHandler} sx={{
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                top: { xs: '60%', lg: '55%' },
                maxWidth: '90px',
                cursor: 'pointer',
                zIndex: 2,
                display: playButtonVisibliy ? 'block' : 'none'
            }}>
                <img style={{ maxWidth: '100%' }} src={play} />
            </Box>
            <video
                playsInline
                onPlay={() => setPlayButtonVisibility(false)}
                onPause={() => setPlayButtonVisibility(true)}
                ref={ref => videoRef = ref}
                controls
                style={{ position: 'relative', left: 0, top: 0, opacity: 1, transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' }}
                width="100%">
                <source src={fileName} />
            </video>
        </Box>
    );
};

export { VideoFrame };